/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1ule%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5ral1dfr%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1crf%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1crf%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30l315cr%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._jf4cnqa1%3Ahover%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bnx8stv%3Ahover%7Btext-decoration-line%3Aunderline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._9oik1r31%3Ahover%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz15cr%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30l3azsu%3Ahover%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazazsu%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ajmmnqa1%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1hmsglyw%7Btext-decoration-line%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bfu1r31%7Btext-decoration-color%3AcurrentColor%7D");
import React, { useRef } from 'react';
import FileIcon from '@atlaskit/icon/core/file';
import ImageIcon from '@atlaskit/icon/core/image';
import PageIcon from '@atlaskit/icon/core/page';
import PagesIcon from '@atlaskit/icon/core/pages';
import StoryIcon from '@atlaskit/icon/core/story';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { Anchor, Box, Inline, Text } from '@atlaskit/primitives/compiled';
import type { Conversation } from '../../../types';
const styles = {
  scopeLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _30l3azsu",
  scopeLinkTooltip: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz15cr _9oik1r31 _1bnx8stv _jf4cnqa1 _30l315cr",
  scopeLinkIconImage: "_2rko12b0 _1bsb1crf _4t3i1crf _5ral1dfr _1o9zidpf _1e0c1ule"
};
export type ScopeRowVariant = 'default' | 'tooltip';
type ConversationScope = NonNullable<Conversation['scopes']>[number];
type ScopeRowScope = Omit<ConversationScope, 'link'> & {
  link: ConversationScope['link'] | undefined;
};
function getScopeIconComponent(scope: ScopeRowScope): typeof PageIcon | null {
  switch (scope.type) {
    case 'image':
      return ImageIcon;
    case 'file':
      return FileIcon;
    case 'jira':
      return StoryIcon;
    case 'confluence':
      switch (scope.sub_type) {
        case 'space':
          return PagesIcon;
        case 'whiteboard':
          return WhiteboardIcon;
        case 'page':
        default:
          return PageIcon;
      }
    default:
      return null;
  }
}
export type ScopeRowProps = {
  scope: ScopeRowScope;
  variant: ScopeRowVariant;
  maxLines: number;
  onFilePreview?: (link: string, name: string) => void;
  onScopeLinkClick?: (variant: ScopeRowVariant) => void;
  onScopeLinkHover?: () => void;
};

/**
 * Renders a single scope as an icon + name wrapped in an anchor.
 * Used in both the first-scope footer and in the tooltip scope list.
 *
 * Shared between `ChatItem` (conversation-assistant-ui-components) and
 * `ChatListItem` (rovo-navigation).
 */
export const ScopeRow = ({
  scope,
  variant,
  maxLines,
  onFilePreview,
  onScopeLinkClick,
  onScopeLinkHover
}: ScopeRowProps): JSX.Element => {
  const textColor = variant === 'tooltip' ? 'color.text.inverse' : 'color.text.subtlest';
  const iconColor = variant === 'tooltip' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
  const isFile = scope.type === 'file' || scope.type === 'image';
  const canUseIconUrl = scope.type === 'link' || scope.type === 'jira';
  const ScopeIcon = getScopeIconComponent(scope);
  const hasRemoteScopeIcon = canUseIconUrl && typeof scope.icon_url === 'string' && scope.icon_url.trim().length > 0;

  // Prefer a remote `icon_url` (links / jira) when present; otherwise fall back to the built-in icon.
  const icon = hasRemoteScopeIcon ? <Box as="img" src={scope.icon_url} alt="" xcss={styles.scopeLinkIconImage} /> : ScopeIcon ? <ScopeIcon label="" size="small" color={iconColor} /> : null;

  // Defensively resolve `link` to a string — the API may return an object or
  // null/undefined for freshly-pasted links before backend normalisation.
  const rawLink = (scope.link as unknown);
  const resolvedLink = typeof rawLink === 'string' ? rawLink : rawLink !== null && typeof rawLink === 'object' ? String((rawLink as Record<string, unknown>).url ?? (rawLink as Record<string, unknown>).href ?? '') : '';

  // Guard: fire the hover analytics event only once per mouseenter/mouseleave
  // cycle, regardless of how many synthetic mouseenter events the browser emits.
  const hasHoveredRef = useRef(false);
  const handleMouseEnter = () => {
    if (!hasHoveredRef.current) {
      hasHoveredRef.current = true;
      onScopeLinkHover?.();
    }
  };
  const handleMouseLeave = () => {
    hasHoveredRef.current = false;
  };
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onScopeLinkClick?.(variant);
    if (isFile && onFilePreview) {
      e.preventDefault();
      onFilePreview(resolvedLink, scope.name);
    }
  };
  if (!resolvedLink) {
    return <Text size="small" weight="regular" maxLines={maxLines} align="start" color={textColor}>
				{scope.name}
			</Text>;
  }
  return <Inline alignBlock="center" space="space.050">
			<Anchor href={resolvedLink} {...isFile ? {} : {
      target: '_blank',
      rel: 'noreferrer'
    }} xcss={variant === 'tooltip' ? styles.scopeLinkTooltip : styles.scopeLink} onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				<Inline alignBlock="center" space="space.050">
					{icon}
					<Text size="small" weight="regular" maxLines={maxLines} align="start" color={textColor}>
						{scope.name}
					</Text>
				</Inline>
			</Anchor>
		</Inline>;
};